<template>
    <div>
       <v-container fluid class="my-5">
           <v-layout row wrap justify-end>
               <v-flex xs12 md3>
                   <!-- here we trigger create user functions -->
                    <NewClientPopUp/>
               </v-flex>
           </v-layout>
           <v-layout row justify-center>
            <v-data-table :headers="headers" :items="allClients" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">
                        <v-chip v-for="field in props.item.fileTypes" :key="field.name" color="primary" text-color="white">{{ field.name }}</v-chip>
                    </td>
                    <td class="text-xs-right">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <NewClientPopUp :edit="props.item.id" :client-name="props.item.name"/>
                            </template>
                            <span>Rename</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <FileTypesPopUp :client-id="props.item.id" :client-name="props.item.name" :file-types="props.item.fileTypes"/>
                            </template>
                            <span>Manage File Types</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn fab dark small color="red" v-on="on" @click="deleteClient({ id: props.item.id })">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>

           </v-layout>
       </v-container>
    </div>
</template>

<script>
import NewClientPopUp from '@/components/Client/NewClientPopUp'
import FileTypesPopUp from '@/components/Client/FileTypesPopUp'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        NewClientPopUp,
        FileTypesPopUp,
    },
    name: 'clients',
    data() {
        return {
            headers: [
                {
                    text: 'Client Name',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                { text: 'File Types', value: 'file-types' },
                { text: 'Actions', value: 'actions', align: 'center' }
            ]
        }
    },
    methods:{
        ...mapActions([
            'deleteClient',
        ]),
        renameClient: function (clientId) {
            console.log('Edit client: ', clientId)
        }
    },
    computed: {
        ...mapGetters([
           'allClients'
        ]),

    },
}
</script>